//@flow
import * as React from 'react';
import AcknowledgeButton from 'app/common/react/components/growth/unauth/signup/AccountRecovery/AcknowledgeButton';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import ResetPasswordButton from 'app/common/react/components/growth/unauth/signup/AccountRecovery/ResetPasswordButton';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Box, Text } from 'gestalt';

type Props = {|
  email: string,
  onClose: () => void,
  onPasswordResetSent: () => void,
  socialButtons: React.Node,
|};

export default function LoginAssistanceModal({
  email,
  onClose,
  onPasswordResetSent,
  socialButtons,
}: Props) {
  return (
    <Modal
      accessibilityCloseLabel={i18n._('close', 'accessible label for button to close modal')}
      accessibilityModalLabel={i18n._(
        'Login with Facebook or Google?',
        'Modal accessibility label for when a user has failed login three times',
      )}
      heading={i18n._(
        'Looks like you’re having trouble logging in',
        'Modal heading for user who have attempted to login three times',
      )}
      onDismiss={onClose}
      role="alertdialog"
      size="md"
    >
      <Box paddingX={6} marginBottom={4}>
        <Box>
          <Text>
            {interpolateNamedTemplate(
              i18n._('We sent an email to {{ email }} to help you get back in.', ''),
              {
                email: (
                  <Text inline key="emailAddress" weight="bold">
                    {email}
                  </Text>
                ),
              },
            )}
          </Text>
          <Box paddingY={3}>
            <ResetPasswordButton
              inline
              color="gray"
              email={email}
              callBack={onPasswordResetSent}
              overrideText={i18n._(
                'Resend email',
                'Button to allow the user to request a password reset email',
              )}
            />
          </Box>
        </Box>
        <Box marginBottom={4}>
          <Text>
            {i18n._(
              'Or log in with Facebook or Google.',
              'Upsell to use Facebook or Google for login',
            )}
          </Text>
        </Box>
        {socialButtons}
        <Box marginTop={4}>
          <AcknowledgeButton onClick={onClose} />
        </Box>
      </Box>
    </Modal>
  );
}
